import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import values from 'lodash/values';
import isEqual from 'lodash/isEqual';
import cx from 'classnames';

import '../styles/MainOptions.scss';

export const OPTIONS = [
    { label: 'Form Design', id: 'formDesign' },
    { label: 'Individual SS', id: 'individualSS' },
    { label: 'Pedigree SS', id: 'pedigreeSS' },
    { label: 'Save/Delete SS Formats', id: 'saveSSFormats' },
    { label: 'Save Icon Formats', id: 'saveIconFormats' },
    { label: 'Save Pedigree Properties', id: 'savePedigreeProperties' },
    { label: 'Enforce Data Entry Validations', id: 'enforceDataEntryValidations' },
    { label: 'Fields', id: 'fields' },
    { label: 'Pedigrees', id: 'pedigrees' },
    { label: 'Individuals', id: 'individuals' },
    { label: 'Orders', id: 'orders' },
    { label: 'Invites', id: 'invites' },
    { label: 'Invites Admin', id: 'invitesAdmin' },
    { label: 'Test Results', id: 'testResults' },
];

export default class MainOptions extends Component {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        options: PropTypes.object.isRequired,
        className: PropTypes.string,
    };

    static defaultProps = {
        options: {},
    };

    state = {
        options: [],
    };

    constructor(props) {
        super(props);

        this.state = {
            options: this.getNormalizedOptions(),
        };
    }

    get options() {
        return values(this.state.options);
    }

    componentDidUpdate(prevProps) {
        const currOptions = Object.values(this.props.options);
        const prevOptions = Object.values(prevProps.options);

        if (!isEqual(currOptions, prevOptions)) {
            this.setState({
                options: this.getNormalizedOptions()
            });
        }
    }

    getNormalizedOptions = () => {
        const { options } = this.props;
        
        return OPTIONS.reduce((acc, { label, id }) => {

            acc[id] = {
                id,
                label: I18n.t(label),
                checked: options[id],
            };

            return acc;
        }, {});
    }

    onChange = (e) => {
        e.persist();

        const { id } = e.target;
        const changingItem = this.options.find((item) => item.id === id);

        this.setState(
            (state) => ({
                options: {
                    ...state.options,
                    [changingItem.id]: {
                        ...changingItem,
                        checked: !changingItem.checked,
                    }
                }
            }),
            () => {
                const { onChange } = this.props;
                const options = this.options.reduce((acc, item) => {
                    acc[item.id] = item.checked;
        
                    return acc;
                }, {}); 
        
                onChange(options); 
            }
        );
    }

    render() {
        const { className } = this.props;

        return (
            <div className={cx('User-details-settings-licensing-options', className)}>
                {this.options.map(({ label, id, checked }) => (
                    <div key={id} className="User-details-settings-licensing-options__item">
                        <input
                            type="checkbox" 
                            id={id}
                            checked={checked}
                            onChange={this.onChange}
                        />
                        <label htmlFor={id}>{label}</label>
                    </div>
                ))}
            </div>
        );
    }
}